import L from "leaflet";

L.StatsIcon = L.DivIcon.extend({
  createIcon: function() {
    var div = document.createElement("div");
    div.className = 'marker';
    div.style.position = 'absolute';
    div.style.backgroundColor  = this.options.color;
    div.style.display = 'block';
    div.style.width = "38px";
    div.style.height = "38px";
    div.style.padding = "2px";
    div.style.border = "none";
    div.style.borderRadius = "15px";

    var img = document.createElement('img');
    img.src = this.options.icon;
    div.appendChild(img);

    this.options.className = "marker-icon";

    this.dom = div;
    this._setIconStyles(this.dom, 'div');

    return this.dom;
  }
});

L.statsIcon = function(options) {
  return new L.StatsIcon(options);
};